module.exports = __webpack_public_path__ + "img/certificate-IE-LD.85d055ad.jpg";